import React from 'react'
import { Auth } from "aws-amplify";

import axios from 'axios';
import './style.css'
import { useState, useEffect } from 'react';
import InputPassword from './InputPasswordBox';
import PasswordValidations from './PwdValidations';
import { getQueryParams } from './utils';
import AgreeModal from './AgreeModal';
import AlertBox from './AlertBox';
import AuthLayout from './AuthLayout';

const PASSWORD_CHANGED_MSG =
  'Your password has been successfully changed. You can now use your new credentials to access the portal. Click Sign In to continue.';

function ResetPasswordForm(props) {

  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [disableSendBtn, setDisableSendBtn] = useState(true)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [changedCredentials, setChangedCredentials] = useState({ email: '', password: '' })
  const isEmployerPortal = process.env.REACT_APP_PORTAL === 'employer'

  const handleConfirmVerification = async (e) => {
    e.preventDefault();
    console.log('calling reset')
    console.log(props.email)
    console.log(verificationCode)
    console.log(password)
    if (password === confirmPassword) {
      props.toggleLoader(true);
      Auth.completeNewPassword(
        props.user,               // the Cognito User Object
        password,       // the new password
      ).then(async (user) => {
        // at this time the user is logged in if no MFA required
        let email = (user.challengeParam && user.challengeParam.userAttributes && user.challengeParam.userAttributes.email)
          || (user.attributes && user.attributes.email)
          || (props.user && props.user.challengeParam && props.user.challengeParam.userAttributes && props.user.challengeParam.userAttributes.email)
          || props.loginUsername
          || "";
        let agentId = user.challengeParam && user.challengeParam.userAttributes
          ? user.challengeParam.userAttributes["custom:agentid"]
          : "";
        
        if (email) {
         await captureEvents(agentId, email, "RESET_PASSWORD");
         if (isEmployerPortal) {
          props.toggleLoader(false);
          try {
            await Auth.signOut();
          } catch (signOutErr) {
            console.log(signOutErr);
          }
          setChangedCredentials({ email, password });
          setShowSuccessAlert(true);
         } else {
          props.autoLoginFromResetPass(email, password);
         }
        } else {
          window.location.reload();
        }
      }).catch(err => {
        props.toggleLoader(false)
        console.log(err.message)
        setErrorMessage(err.message)
      });



    }
    else {
      setErrorMessage('Please enter same password')
      // setbuttonStatus(true)
    }
  }
  const captureEvents = async (agentId, email, eventState) => {
    try {
      let data = {
        agentId: agentId,
        eventState: eventState,
        createdBy: email,
      };
      let apiPath = process.env.REACT_APP_BASE_ROOT_URL + `/agency/api/v1/agent-event`;
      const response = await axios.post(apiPath, data);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      console.error("API call failed", error);
    }
  };



  const handleChange = (e) => {
    // console.log(e.target.value)
    if (e.target.name == 'password') {
      setPassword(e.target.value)
    }
    else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
    // if(password==confirmPassword){
    //   setbuttonStatus(false)
    // }
    // else{
    //   console.log(password)
    //   console.log(confirmPassword)
    // }

  };
  const toggleResetBtn = (allPassed) => {
    setDisableSendBtn(!allPassed);
  }
  const closeModal = () =>{
    props.closeModal()
    console.log("close modal")
  }

  const handleSuccessAlertClose = () => {
    setShowSuccessAlert(false);
    if (props.onPasswordChangeSuccess) {
      props.onPasswordChangeSuccess(changedCredentials.email, changedCredentials.password);
    }
  }


  return (

    <AuthLayout>
      <p style={{ marginTop: 0, paddingBottom: 16 }}>Please enter your new password below.</p>
      <form className="auth-form">
        <InputPassword handleChange={handleChange} name={'password'} placeholder="New password" />
        <InputPassword handleChange={handleChange} name={'confirmPassword'} placeholder="Enter new password again" />
        <p className="a-errorMessage" hidden={errorMessage.length <= 0}>
          {errorMessage}
        </p>
        <PasswordValidations password={password} allPassed={toggleResetBtn} />
        <button type="submit" disabled={disableSendBtn} className="auth-btn-primary" onClick={handleConfirmVerification}>
          OK
        </button>
      </form>
      <AgreeModal agreeModal={props.agreeModal} closeModal={()=>closeModal()}/>
      <AlertBox
        showAlert={showSuccessAlert}
        alertTitle="Message"
        alertMsg={PASSWORD_CHANGED_MSG}
        showOk={true}
        closeAlert={handleSuccessAlertClose}
      />
    </AuthLayout>



    // {/* <form onSubmit={props.handleSubmit}>
    //         <div className="container">
    //           <h1>reset password</h1>
    //           <p>Please fill in this form to login.</p>
    //           <hr />
    //           <label >
    //             <b>verificationCode</b>
    //           </label>
    //           <input
    //             type="text"
    //             placeholder="Enter verificationCode"
    //             name="verificationCode"
    //             required
    //             onChange={props.handleChange}
    //           />
    //     <br/>
    //     <label >
    //                     <b>new Password</b>
    //                   </label>
    //                   <input
    //                     type="password"
    //                     placeholder="Enter new Password"
    //                     name="password"
    //                     required
    //                     onChange={props.handleChange}
    //                   />
    //           <div className="clearfix">

    //             <button type="submit" className="signupbtn" onClick={props.handleConfirmVerification}>
    //               send verification code
    //             </button>
    //           </div>
    //         </div>
    //       </form> */}


  )

}

export default ResetPasswordForm
